import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import styles

export const ProductDescriptions = ({ data, setData }) => {
  const handleChange = (value) => {
    setData((prev) => ({
      ...prev,
      productDescriptions: { ...prev.productDescriptions, description: value },
    }));
  };

  return (
    <div className="bg-[#f0f0f0] dark:bg-[#282828] p-4 rounded-lg my-4">
      <div className="flex items-center space-x-2">
        <div className="bg-[#FFBE7C] w-4 h-4 rounded-lg" />
        <h1>Product Description</h1>
      </div>

      <ReactQuill
        theme="snow"
        value={data.productDescriptions?.description || ""}
        onChange={handleChange}
        placeholder="What is it? Audience - Who will benefit from your digital product? Problem area - What problem does it solve? Why is it better than the competition?"
        className={`custom-quill ${localStorage.getItem('dark') === 'true' ? 'dark' : ''} my-4`}
      />
    </div>
  );
};
